import { createFileRoute } from '@tanstack/react-router'
import { MyAssetsPage } from '@/features/assets/pages/my-assets-page'

export const Route = createFileRoute('/_authenticated/_sidebar/investor/my-assets')({
  component: MyAssets,
})

function MyAssets() {
  return <MyAssetsPage />
}

